import { FormBuilder } from "@angular/forms";
import { FormGroup } from "@angular/forms";
import { NotificacionesCorreosMasivosService } from "./../notificaciones-correos-masivos.service";
import { Component, OnInit } from "@angular/core";
import { PageEvent } from "@angular/material/paginator";
import { ViewportScroller } from "@angular/common";
import { AuthService } from "src/app/shared/services/auth.service";
export enum TipoOrdenamiento{
  Ascendente = 1,
  Descendente = 2,
  Ninguno = 3
}
@Component({
  selector: "app-notificaciones-correos-masivos-enviados",
  templateUrl: "./notificaciones-correos-masivos-enviados.component.html",
  styleUrls: ["./notificaciones-correos-masivos-enviados.component.scss"],
})
export class NotificacionesCorreosMasivosEnviadosComponent implements OnInit {
  tipo_ordenamiento_fecha    = 3;
  tipo_ordenamiento_para     = 3;
  tipo_ordenamiento_asunto   = 3;
  length = 0;
  pageSize = 0;
  pageEvent: PageEvent;
  listado: any[] = [];
  mensaje: any = null;
  public isCollapsed = true;
  textoBuscarPor: string = "";
  filtro: FormGroup;
  filtroOrder: FormGroup;
  constructor(
    private notificacionesService: NotificacionesCorreosMasivosService,
    private viewport: ViewportScroller,
    private fb: FormBuilder,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.formFiltro();
    this.paginador(null);
  }
  filterChanges(event: number): void{
    switch(event){
      case 1: 
        this.filtroOrder.get('leidos').setValue(true);
        this.filtroOrder.get('no_leidos').setValue(false);
        break;
      case 2: 
        this.filtroOrder.get('leidos').setValue(false);
        this.filtroOrder.get('no_leidos').setValue(true);
        break;
    }
    this.paginador(null);
  }
  formFiltro(): void {
    this.filtro = this.fb.group({
      numeroPagina: 1,
      codigo_camara:
        this.authService.getCamaraUser() !== "98"
          ? this.authService.getCamaraUser()
          : "",
      traer_leidos: 0,
      buscar_por: "",
      organizar_por: ' FECHA_CREACION DESC',
    });
    this.filtroOrder = this.fb.group({
      leidos: [false],
      no_leidos: [true],
      fecha : [false],
      para  : [false],
      asunto: [false]
    });
  }
  getOrderByQuery(): void{
    let arrayValues : string [] = [];
    if(this.tipo_ordenamiento_fecha == 1){
      arrayValues.push('FECHA_CREACION ASC');
    }else if(this.tipo_ordenamiento_fecha == 2){
      arrayValues.push('FECHA_CREACION DESC');
    }
    if(this.tipo_ordenamiento_asunto == 1){
      arrayValues.push('MAS.ASUNTO ASC');
    }else if(this.tipo_ordenamiento_asunto == 2){
      arrayValues.push('MAS.ASUNTO DESC');
    }
    if(this.tipo_ordenamiento_para == 1){
      arrayValues.push('MAS.NOMBRE_RECEPTOR ASC');
    }else if(this.tipo_ordenamiento_para == 2){
      arrayValues.push('MAS.NOMBRE_RECEPTOR DESC');
    }
    this.filtro.get('organizar_por').setValue((arrayValues.join(','))? arrayValues.join(','):'FECHA_CREACION DESC');
  }
  paginador(event: any): void {
    if (event) {
      this.filtro.patchValue({
        numeroPagina:
          this.pageEvent.pageIndex + 1,
      });
    }
    if(this.filtroOrder.value.leidos === true){
      this.filtro.get('traer_leidos').setValue(1);
    }else{
      this.filtro.get('traer_leidos').setValue(0);
    }
    this.getOrderByQuery();
    this.notificacionesService
      .getMensajesEnviados(this.filtro.value)
      .subscribe((x: any) => {
        this.listado = x.data.items;
        this.length = x.data.paging.totalItems;
        this.pageSize = x.data.paging.pageSize;
      });
    this.mensaje = null;
  }

  setMensaje(item: any): void {
    this.mensaje = item;
    this.viewport.scrollToPosition([0, 0]);
  }

  valoresFiltro(valor: any, control: string, event: any): void {
    event.stopPropagation();
    this.filtro.get(control).setValue(valor);
    this.paginador(null);
  }

  cancelarFiltro(): void {
    this.filtro.patchValue({
      traer_leidos: 0,
      buscar_por: "",
      organizar_por: 0,
    });

    this.paginador(null);
  }
  aumentarPorTipo(type: number): void{
    switch(type){
      case 1:
        this.tipo_ordenamiento_fecha ++;
        if(this.tipo_ordenamiento_fecha > 3) this.tipo_ordenamiento_fecha = 1;
        break;
      case 2:
        this.tipo_ordenamiento_para ++;
        if(this.tipo_ordenamiento_para > 3) this.tipo_ordenamiento_para = 1;
        break;
      case 3:
        this.tipo_ordenamiento_asunto ++;
        if(this.tipo_ordenamiento_asunto > 3) this.tipo_ordenamiento_asunto = 1;
        break;
    }
    this.paginador(null);
  }
  
}
